import React, { useState, useEffect } from 'react';
import AgeGate from './components/AgeGate';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Services from './components/Services';
import Rules from './components/Rules';
import Lessons from './components/Lessons';
import Contact from './components/Contact';
import Footer from './components/Footer';
import DivineBadge from './components/DivineBadge';
import translations from './translations';
import { getDpLang, setDpLang } from './dpLang';
import './App.css';

export default function App() {
  const [lang, setLang] = useState(getDpLang);
  const t = translations[lang];

  const toggleLang = () => {
    setLang(prev => {
      const next = prev === 'en' ? 'cs' : 'en';
      setDpLang(next);
      return next;
    });
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div className="app">
      <AgeGate />
      <Navbar
        t={t.nav}
        lang={lang}
        toggleLang={toggleLang}
      />
      <Hero t={t.hero} />
      <About t={t.about} />
      <Gallery t={t.gallery} />
      <Services t={t.services} />
      <Lessons t={t.lessons} />
      <Rules t={t.rules} />
      <Contact t={t.contact} />
      <Footer t={t.footer} />
      <DivineBadge />
    </div>
  );
}
